
type PropsType = {
    headerText: string;
    contentText: string
}

const DataEmpty = ({headerText, contentText}: PropsType) => {
    return (<div className="tsk-lists empty-screen-wrap">
    <div className="card-ui">
      <div className="icon-block-wrap"> <span
        className="tsk-icon material-icons-round">ramen_dining</span> </div>
      <h3>{headerText}</h3>
      <p>{contentText}</p>
    </div>
  </div>)
}

export default DataEmpty